import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { flexColumn, border } from "shared/theme/mixins";

export const StyledAuthPage = styled(Box)`
  ${flexColumn({ ai: "center", jc: "center" })};
  width: 100%;
  height: 100vh;
  row-gap: 1.5rem;
`;

export const StyledForm = styled(Box)`
  ${border()}
  border-radius: 16px;
  flex-direction: column;
  padding: 1.5rem;
  width: 480px;
  position: relative;
  box-sizing: border-box;
`;

export const StyledInputsContainer = styled(Box)`
  position: relative;
`;

export const StyledErrorContainer = styled(Box)`
  position: absolute;
  bottom: -25px;
  left: 0;
`;

export const StyledLogoWrapper = styled(FlexCenter)`
  width: 158px;
  height: 46px;

  img {
    width: 100%;
    height: 100%;
  }
`;
